import { useState, useEffect } from 'react';
import { getAllServicesStatus } from '../actions/healthCheckActions';

export const useServicesStatus = () => {
  const [servicesStatus, setServicesStatus] = useState({
    backend: 'Verificando...',
    mongodb: 'Verificando...',
    postgresql: 'Verificando...',
    overallStatus: 'checking',
    version: 'N/A',
    timestamp: ''
  });
  const [isLoading, setIsLoading] = useState(true);

  // Verificar el estado de todos los servicios
  const verifyAllServices = async () => {
    try {
      const status = await getAllServicesStatus();
      setServicesStatus(status);
    } catch (error) {
      console.error('Error al verificar servicios:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Efecto para verificar servicios al cargar y establecer intervalo
  useEffect(() => {
    verifyAllServices();
    
    // Actualizar cada 2 minutos
    const interval = setInterval(verifyAllServices, 120000);
    return () => clearInterval(interval);
  }, []);

  // Calcular si hay servicios offline
  const hasOfflineServices = Object.values(servicesStatus).some(status => status === 'offline');

  return {
    servicesStatus,
    isLoading,
    hasOfflineServices,
    verifyAllServices
  };
};
